import React from "react";
import BasicUserInformation from "../BasicUserInformation/BasicUserInformation";
import CollapsableWrapper from "../CollapsableWrapper/CollapsableWrapper";
import AddressData from "../AddressData/AddressData";
import MappedRegistrationComponent from "../MappedRegistrationComponent/MappedRegistrationComponent";
import OfficeAddress from "../OfficeAddress/OfficeAddress";
import BasicReviserData from "../BasicReviserData/BasicReviserData";
import ButtonComponent from "../../UI/ButtonComponent/ButtonComponent";
import NameAndAddressData from "../NameAndAddressData/NameAndAddressData";
import RegistrationComponent from "../RegistrationComponent/RegistrationComponent";
import Col from "../WrapperComponents/Col";
import Row from "../WrapperComponents/Row";
import InputComponent from "../../UI/InputComponent/InputComponent";
import { Spinner } from "react-bootstrap";
import ContactInformationMultiple from "../ContactInformationMultiple/ContactInformationMultiple";
function EntryForm2(props) {
  const { officeAddress } = props.parentState.newFormData;
  const mappedOfficeAddress = officeAddress.map((element, index) => {
    return (
      <CollapsableWrapper
        key={`office-address-collapse${index}`}
        {...props}
        id={element.id}
        multiple
        clickText={`Adresa ureda ${
          officeAddress.length > 1 ? `(${index + 1})` : ""
        }`}
      >
        <OfficeAddress
          objData={{ group: "officeAddress" }}
          id={element.id}
          idZaBtn={index}
          {...props}
        />
      </CollapsableWrapper>
    );
  });

  const { competentBodyData } = props.parentState.newFormData;
  const mappedCompetentBodyData = competentBodyData.map((element, index) => {
    return (
      <CollapsableWrapper
        key={`comp-body-data-collapse${index}`}
        clickText={`Nadležna tijela država članica odgovorna za nadzor osiguranja kvalitete rada i nadzor ovlaštenih revizora i revizorskih društava 
        ${competentBodyData.length > 1 ? `(${index + 1})` : ""}`}
      >
        <NameAndAddressData
          group={"competentBodyData"}
          id={element.id}
          idZaBtn={index}
          {...props}
        />
      </CollapsableWrapper>
    );
  });

  const { reviserRegForeignCountry } = props.parentState.newFormData;
  const mappedReviserRegForeignCountry = reviserRegForeignCountry.map(
    (element, index) => {
      return (
        <CollapsableWrapper
          key={`reviser-reg-foreign-country${index}`}
          clickText={`Registracija samostalnog revizora kod nadležnog tijela drugih država članica ${
            reviserRegForeignCountry.length > 1 ? `(${index + 1})` : ""
          }`}
        >
          <MappedRegistrationComponent
            {...props}
            id={element.id}
            idZaBtn={index}
            regId={"rev-reg-foreign"}
            onChange={props.mappedUserInputHandler}
            inputValue={props.parentState.newFormData.reviserRegForeignCountry}
            group="reviserRegForeignCountry"
          />
        </CollapsableWrapper>
      );
    }
  );

  const { thirdCountryRegistration } = props.parentState.newFormData;
  const mappedThirdCountryRegistration = thirdCountryRegistration.map(
    (element, index) => {
      return (
        <CollapsableWrapper
          key={`third-country-registration${index}`}
          clickText={`Registracije u drugoj državi članici kao subjekta za obavljanje revizije u trećoj zemlji ${
            thirdCountryRegistration.length > 1 ? `(${index + 1})` : ""
          }`}
        >
          <MappedRegistrationComponent
            {...props}
            id={element.id}
            idZaBtn={index}
            onChange={props.mappedUserInputHandler}
            inputValue={props.parentState.newFormData.thirdCountryRegistration}
            group="thirdCountryRegistration"
          />
        </CollapsableWrapper>
      );
    }
  );

  const { basicReviserData } = props.parentState.newFormData;
  const mappedBasicReviserData = basicReviserData.map((element, index) => {
    return (
      <CollapsableWrapper
        key={`reviser-data-collapse${index}`}
        clickText={`Ovlašteni revizor ${
         element.ime && element.prezime ? `(${element.ime}  ${element.prezime})` : "(Novi unos)"
        }`}
      >
        <BasicReviserData
          group="basicReviserData"
          disabled
          handleFetch={props.getReviserDataByOib}
          id={element.id}
          idZaBtn={index}
          {...props}
        />
      </CollapsableWrapper>
    );
  });

  const { contactInformation } = props.parentState.newFormData;

  const getContactInfo = contactInformation.map((element, index) => {
    return (
      <CollapsableWrapper
        key={`contact-information-collapse${index}`}
        clickText={`Osoba za kontakt ${
          contactInformation.length > 1 ? `(${index + 1})` : ""
        } `}
      >
        <ContactInformationMultiple id={element.id} idZaBtn={index} {...props} />
      </CollapsableWrapper>
    );
  });

  //disable childa autocomplete inputa ako parent nije odabran
  const disableCounty = props.parentState.newFormData.address.sifDrzave
    ? false
    : true;
  const disableCity = props.parentState.newFormData.address.sifZupanije
    ? false
    : true;
  const disableDistrict = props.parentState.newFormData.address.sifGrdOpc
    ? false
    : true;

  const { userData } = props.parentState.newFormData;

  return (
    <div>
      <CollapsableWrapper clickText="Osnovni podaci">
        <BasicUserInformation
          disabled={
            props.parentState.newFormData.oznDokumenta.oznDokumenta !== null &&
            props.parentState.update &&
            props.parentState.newFormData.userData.oznAkt == 1
          }
          required
          {...props}
        />
        <Row>
          <Col>
            <InputComponent
              required
              style={
                props.parentState.error && userData.mbr.length < 1 && "red"
              }
              onChange={props.userInputHandler}
              objData={{ group: "userData" }}
              value={userData.mbr}
              id="mbr"
              name="mbr"
              type={"number"}
              controlLabel={"Matični broj"}
            />
          </Col>
          <Col></Col>
          <Col></Col>
        </Row>
      </CollapsableWrapper>
      <CollapsableWrapper clickText="Podaci o adresi i registraciji">
        <AddressData
          requiredRegistration
          permitDateLabel="Datum odobrenja za rad"
          permitNumberLabel="Broj odobrenja za rad"
          disableCounty={disableCounty}
          disableCity={disableCity}
          disableDistrict={disableDistrict}
          required
          {...props}
        />
      </CollapsableWrapper>
      {getContactInfo}
      {mappedOfficeAddress}
      {mappedBasicReviserData}

      {mappedReviserRegForeignCountry}
      {mappedThirdCountryRegistration}

      {mappedCompetentBodyData}
      <br></br>
      <div className="invert">
        {props.parentState.loader ? (
          <ButtonComponent disabled>
            <Spinner
              as="span"
              animation="border"
              size="sm"
              role="status"
              aria-hidden="true"
            />{" "}
            Spremanje...
          </ButtonComponent>
        ) : (
          <ButtonComponent onClick={props.submitHandler}>
            {props.parentState.update ? "Spremi promjene" : "Unos u registar"}
          </ButtonComponent>
        )}
      </div>
    </div>
  );
}

export default EntryForm2;
